import { httpService } from '../..';
import { IEntityWithMessages } from '../../services/HttpService';
import { ApiUrls } from '../ApiUrls';
import {
  IBlobFile,
  IBlobReference,
  IBlobRenameRequest,
  IBlobRenameResponse,
  ISalesDocumentPermissionUpdate,
  SasTokenRequestType
} from './filesInterfaces';

export async function fetchSalesDocument(prefix?: string): Promise<IBlobFile[]> {
  if (prefix) {
    prefix = encodeURIComponent(decodeURIComponent(prefix));
  }

  try {
    const response = await httpService.get(ApiUrls.salesDocuments(prefix));
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function fetchFiles(ref: IBlobReference): Promise<IBlobFile[]> {
  try {
    const response = await httpService.get(ApiUrls.files(ref));
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function deleteSalesDocument(uri: string): Promise<void> {
  uri = encodeURIComponent(decodeURIComponent(uri));

  try {
    await httpService.delete(ApiUrls.salesDocument(), uri);
  } catch (e) {
    throw e;
  }
}

export async function getAzureStorageSas(type: SasTokenRequestType): Promise<{ expiresAt: string; sas: string }> {
  try {
    const response = await httpService.get(ApiUrls.azureStorageSas(type));
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function renameFile(request: IBlobRenameRequest): Promise<IEntityWithMessages<IBlobRenameResponse>> {
  try {
    const response = await httpService.put(ApiUrls.files(), request);
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function setSalesDocumentPermissions(
  data: ISalesDocumentPermissionUpdate
): Promise<IEntityWithMessages<IBlobFile[]>> {
  try {
    const response = await httpService.post(ApiUrls.salesDocument(), data);
    return await response.json();
  } catch (e) {
    throw e;
  }
}
